module.exports = __webpack_public_path__ + "img/2012-08-18 17.08.12.6a7967bf.jpg";